import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const activities = [
  { name: "Alpinism", image: "https://images.unsplash.com/photo-1520208422220-d12a3c588e6c?auto=format&fit=crop&w=800&q=80" },
  { name: "Backcountry", image: "https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=800&q=80" },
  { name: "Basecamp", image: "https://images.unsplash.com/photo-1523987355523-c7b5b0dd90a7?auto=format&fit=crop&w=800&q=80" }
];

const ShopByActivity = () => {
  return (
    <section className="py-20 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-4xl font-black uppercase tracking-tighter mb-10 border-l-4 border-orange-600 pl-4">
          Choose Your Domain
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {activities.map((act, idx) => (
            <div key={idx} className="group relative h-[400px] overflow-hidden bg-zinc-900 border border-zinc-800 cursor-pointer">
              <div 
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105 opacity-60 group-hover:opacity-40"
                style={{ backgroundImage: `url(${act.image})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/40 to-transparent" />
              
              <div className="absolute bottom-0 left-0 w-full p-8 flex items-end justify-between">
                <h3 className="text-3xl font-black uppercase tracking-tighter">{act.name}</h3>
                <div className="w-12 h-12 bg-orange-600 flex items-center justify-center translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300 border border-orange-400">
                  <SafeIcon icon={FiArrowRight} className="w-6 h-6 text-white" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ShopByActivity;